<!-- RadioButtonInput -->
<script lang="ts" setup>
import { computed } from 'vue';
import { LayoutOrientation } from '../Enums/UiEnums';
import { randomId } from '../lib/ChoiceUtils';
import '../../css/choice.css';

    const props = defineProps<{
        modelValue?: any,   // Use with v-model
        value?: any,         // Value assocaited with the radio button selection
        layout?: LayoutOrientation,
        disabled?: boolean
    }>();

    const emit = defineEmits(["update:model-value"]);
    const inputId = `input_${randomId()}`;

    function EmitEleValue(evt: Event)
    {
        if (props.disabled)
            return;

        if (props.value === props.modelValue) { 
            return;
        }
        emit("update:model-value", props.value);
    }
    const layoutMode = computed<LayoutOrientation>(() => props.layout ?? LayoutOrientation.Vert);
    const componentClass = computed<string>(() => LayoutOrientation.Vert == layoutMode.value ? "form-check form-check-inline" : "me-3 form-check-inline");
    const radioClass = computed<(string|undefined)[]>(() => [LayoutOrientation.Vert == layoutMode.value ? "form-check-input" : "form-check-input me-1", "input-border"]);

    const isChecked = computed(() => props.modelValue === props.value);

</script>
<template>
    <span :class="componentClass" @click="EmitEleValue">
        <input 
            :id="inputId"
            :class="radioClass" 
            type="radio" 
            :checked="isChecked" 
            @input="EmitEleValue" 
            @change="EmitEleValue"
            :disabled="true === props.disabled" />

        <label class="form-check-label" :for="inputId">
            <slot></slot>
        </label>
    </span>
</template>